import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "companies",
  "use": "companies-usage",
  "viewBox": "0 0 22 20",
  "content": "<symbol viewBox=\"0 0 22 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"companies\"><path clip-rule=\"evenodd\" d=\"M1.625 7.126a1.5 1.5 0 011.5-1.5h15.75a1.5 1.5 0 011.5 1.5v9.5a1.5 1.5 0 01-1.5 1.5H3.125a1.5 1.5 0 01-1.5-1.5v-9.5z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M14.75 5.626a3.75 3.75 0 10-7.5 0M1.625 10.626H9.75M12.25 10.626h8.125\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path clip-rule=\"evenodd\" d=\"M11 12.5c-.69 0-1.25-.56-1.25-1.25V10a1.25 1.25 0 112.5 0v1.25c0 .69-.56 1.25-1.25 1.25z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/companies.svg
// module id = NrwT
// module chunks = 39 44